// import Slide from 'yet-another-react-lightbox';
import { useEffect, useMemo, useState } from 'react';
import { IDriveContent } from 'src/@types/drive';
import Lightbox, { Slide } from 'src/components/lightbox';
import { Pdf } from 'src/components/lightbox/PdfPlugin';
import { DriveRequests } from 'src/requests/drive';
import Video from 'yet-another-react-lightbox/plugins/video';

type Props = {
  file: IDriveContent;
  filePublicUrl?: string;
  onClose(): void;
};

export const DriveMediaContentView = ({
  filePublicUrl,
  file,
  onClose,
}: Props) => {
  const [fileUrl, setFileUrl] = useState<string | null>(filePublicUrl || null);

  useEffect(() => {
    if (filePublicUrl) return;
    const fetchFileUrl = async () => {
      if (file._id) {
        try {
          const { url } = await DriveRequests.getDownloadUrl(file._id);
          setFileUrl(url);
        } catch (error) {
          console.error('Failed to get file URL', error);
        }
      }
    };

    fetchFileUrl();
  }, [file._id, filePublicUrl]);

  const isVideoMimeType = (mimeType: string) =>
    /video\/([0-9A-Za-z!#$%&'*+.^_`|~-]+)/.test(mimeType);

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  const mediaLightboxSlides = useMemo(() => {
    const slides: Slide[] = [];
    if (fileUrl && file.mimeType) {
      if (isVideoMimeType(file.mimeType)) {
        slides.push({
          type: 'video',
          width: 1280,
          height: 720,
          sources: [{ src: fileUrl, type: file.mimeType }],
        });
      } else if (file.mimeType.includes('audio')) {
        slides.push({
          type: 'video',
          sources: [{ src: fileUrl, type: file.mimeType }],
        });
      } else if (file.mimeType.includes('pdf')) {
        slides.push({
          type: 'pdf',
          src: fileUrl,
        });
      } else if (file.mimeType.includes('image')) {
        slides.push({
          type: 'image',
          src: fileUrl,
        });
      }
    }

    return slides;
  }, [fileUrl, file.mimeType]);

  return fileUrl ? (
    <Lightbox
      plugins={[Video, Pdf]}
      index={0}
      slides={mediaLightboxSlides}
      open
      close={onClose}
    />
  ) : null;
};
